import React from 'react';

import { StyledMessage } from './InputMessage.styles';

import { InputMessageType } from './types';

export interface InputMessageProps {
  /**
   * Component contents
   */
  message: string;
  /**
   * Component disabled state
   */
  disabled?: boolean;
  /**
   * Component type
   */
  type?: InputMessageType;
}

/**
- The InputMessage component should be used to notify user about expected input value and error.
**/
const InputMessage = ({
  message,
  type = 'normal',
  disabled = false,
}: InputMessageProps) => (
  <StyledMessage disabled={disabled} type={type}>
    {message}
  </StyledMessage>
);

export default InputMessage;
